@if (!hidden && links && componentVisibilityService.subNavigationVisibility()) {
    @if (title && layout !== 'Grid') {
        <ds-card class="card-alignment" msThemedCard [border]="false" [themeBorder]="themeBorder" [radius]="true" [elevated]="false">
            <ds-card-header msThemedCardHeader surface="lowest" [title]="title" [themedSurface]="themedSurface" />

            <ng-container *ngTemplateOutlet="sectionLinksTemplate" />
        </ds-card>
    } @else {
        @if (title) {
            <div class="item-header col-12 quick-links">{{ title }}</div>
        }
        <ng-container *ngTemplateOutlet="sectionLinksTemplate" />
    }
}

<ng-template #sectionLinksTemplate>
    <ms-top-bottom-sectionlinks
        [showArrows]="false"
        [items]="links ?? []"
        [tracking]="'quickLinks'"
        [itemClass]="'col-12'"
        [itemListClass]="'list row mb-0 shadow-none'"
        [moduleName]="title"
        [modulePosition]="0"
        [moduleSection]="'Left_'"
        [layout]="layout"
        [showSmallIcons]="smallIcon" />
</ng-template>
